import React, { useState, useRef, useEffect } from 'react'
import 'leaflet/dist/leaflet.css'

import Modal from '../components/Modal'
import { useData } from '../lib/hooks'
import pic03 from '../assets/images/pic03.jpg'



export default ( ) => {
    const previewImage = pic03
    const [ showSubscribeModal, setShowSubscribeModal ] = useState( false )

    const subscribe = ( event ) => {
        event.preventDefault()
    }

    useEffect( () => {
        
    }, [] )

    return (
        <div className="newsletter-preview">
            <span className="image fit"><img src={previewImage} onClick={() => setShowSubscribeModal( true ) } /></span>
            <Modal show={showSubscribeModal} handleClose={() => setShowSubscribeModal( false )}>
                <p>Subcribe to view our entire newsletter</p>
                <span className="image fit"><img src={previewImage} /></span>
                <form className="login-form" onClick={subscribe}  >
                    <input type="text" name="email" placeholder="example@example.com" style={{ marginBottom: "2px" }} /><br/>
                    <input className="button special" type="submit" value="Subscribe" style={{ display: "inline" }}/>
                    
                </form>
            </Modal>
        </div>
    )

}